<template>
  <div>
    
    <div class="row">
      <div class="col-sm-12 col-md-3">

        <div class="card">
          <div class="card-body">

          <p class="card-title">
            Create {{ $route.meta.title }}
            <template v-if="client && client.uuid">
              for {{ client.client_reference }} {{ client.first_name }} {{ client.last_name }}
            </template>
          </p>

          <p>Create a one-off outstanding payment.</p>

    <form @submit.prevent="postForm()">

      <div class="form-group">
            <label for="amount">Amount</label>
            <input
              id="amount"
              v-model="form.amount"
              type="text"
              class="form-control"
              :disabled="processing"
              required
            >
        </div>

          <div class="form-group">
            <label for="reference">Payment Reference</label>
            <input
              id="reference"
              v-model="form.reference"
              type="text"
              class="form-control"
            >
          </div>

          <div class="form-group">
            <label for="contact">Contact</label>
            <input id="contact" type="text" class="form-control" v-model="form.contact">
            <small class="form-text text-muted">Phone number or email address of the payee.</small>
          </div>

      <button
        type="submit"
        class="btn btn-success"
        :disabled="processing"
      >
        Create
      </button>
    </form>

          </div><!--Body-->
        </div><!--Card-->

        <div class="card mt-3">
          <div class="card-body">

            <p class="card-title">
              Search {{ $route.meta.title }}s
            </p>                     

            <form @submit.prevent="searchRecords()">
              <div class="form-group">
                <label
                  for="search"
                  class="sr-only"
                >Search {{ $route.meta.title }}s</label>
                <input
                  id="search"
                  v-model="queries.search"
                  type="search"
                  class="form-control"
                  placeholder="Search by payment reference"
                >
              </div>

              <div class="form-group">
                <label for="payment_type">Payment Type</label>
                <select
                  id="payment_type"
                  v-model="queries.type"
                  class="form-control"
                  :disabled="processing"
                >
                  <option value="" />
                  <template v-for="payment_type in payment_types">
                    <option
                      :value="payment_type"
                    >
                      {{ payment_type }}
                    </option>
                  </template>
                </select>
              </div>

              <div class="form-group">
                <label for="payment_descriptions">Payment Description</label>
                <select
                  id="payment_descriptions"
                  v-model="queries.description"
                  class="form-control"
                  :disabled="processing"
                >
                  <option value="" />
                  <template v-for="payment_description in payment_descriptions">
                    <option
                      :value="payment_description"
                    >
                      {{ payment_description }}
                    </option>
                  </template>
                </select>
              </div>

              <template v-if="options.payment_statuses && options.payment_statuses.length > 0">
                <div class="form-group">
                  <label for="search_status">Status</label>
                  <select
                    id="search_status"
                    v-model="queries.status"
                    class="form-control"
                    :disabled="processing"
                  >
                    <option
                      value=""
                      disabled
                    >
                      Select status
                    </option>
                    <option
                      v-for="status in options.payment_statuses"
                      :key="status.label"
                      :value="status.label"
                    >
                      {{ status.label }}
                    </option>
                  </select>
                </div>
              </template>

              <div class="form-group">
                <label for="search_case_number">Case Number</label>
                <input id="search_case_number" type="text" class="form-control" v-model="queries.case_number">
              </div>

              <div class="form-group">
                <label for="search_citation">Citation</label>
                <input id="search_citation" type="text" class="form-control" v-model="queries.citation">
              </div>

              <div class="form-group">
                <label for="search_contact">Contact</label>
                <input id="search_contact" type="text" class="form-control" v-model="queries.search_contact">
              </div>

              <div class="form-group">
                <label for="location">Location</label>
                <select
                  id="location"
                  v-model="queries.location"
                  class="form-control"
                  :disabled="processing"
                >
                  <option value="">
                    Any
                  </option>
                  <option value="none">
                    No Location
                  </option>
                  <template v-if="locations && locations.length > 0">
                    <template v-for="(location, index) in locations">
                      <option
                        :value="location.uuid"
                      >
                        {{ location.name }}
                      </option>
                    </template>
                  </template>
                </select>
              </div>


              <div class="form-group">
                <label for="portal">Portal</label>
                <select
                  id="portal"
                  v-model="queries.portal"
                  class="form-control"
                  :disabled="processing"
                >
                  <option value="">
                    Any
                  </option>
                  <option value="none">
                    No Portal
                  </option>
                  <template v-if="portals && portals.length > 0">
                    <template v-for="(portal, index) in portals">
                      <option
                        :value="portal.uuid"
                      >
                        {{ portal.name }}
                      </option>
                    </template>
                  </template>
                </select>
              </div>

              <div class="form-group">
                <label for="created_by">Creator</label>
                <select
                    id="created_by"
                    v-model="queries.created_by"
                    class="form-control"
                    :disabled="processing"
                >
                  <option value="" />
                  <template v-for="(creator, index) in users">
                    <option
                        :value="creator.email"
                    >
                      {{ creator.name }} {{ creator.email }}
                    </option>
                  </template>
                </select>
              </div>


              <div class="row">
                <div class="col-md-12 col-lg-6">
                  <div class="form-group custom-control custom-switch">
                    <input
                      id="archived"
                      v-model="queries.archived"
                      type="checkbox"
                      class="custom-control-input"
                      :disabled="processing"
                    >
                    <label
                      class="custom-control-label"
                      for="archived"
                    >Archived</label>
                  </div>
                </div><!--Col-->

                <div class="col-md-12 col-lg-6">
                  <div class="form-group custom-control custom-switch">
                    <input
                      id="trashed"
                      v-model="queries.trashed"
                      type="checkbox"
                      class="custom-control-input"
                      :disabled="processing"
                    >
                    <label
                      class="custom-control-label"
                      for="trashed"
                    >Trashed</label>
                  </div>
                </div><!--Col-->
              </div><!--Row-->

              <button
                type="submit"
                class="btn btn-primary"
                :disabled="processing"
              >
                Search
              </button>
            </form>
          </div><!--Body-->
        </div><!--Card-->

      </div><!--Col-->


      <div class="col-sm-12 col-md-9">

        <div class="card">
          <div class="card-body">

            <p class="card-title">
                  {{ records.length }} of {{ total.toLocaleString() }} {{  $route.meta.title }}s
            </p>

            <data-table :fields="columns" :queries="queries" :base_url="$route.meta.base_url" :records="records" />


            <template v-if="!processing && records && !records.length">
              <div class="alert alert-warning">
                No {{ $route.meta.title }}s found.
              </div>
            </template>
          </div><!--Body-->
        </div><!--Card-->

        <template v-if="records && records.length && total > records.length">
          <div class="row mt-3">
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-outline-primary"
                :disabled="processing"
                @click="getRecords()"
              >
                Load more
              </button>
            </div><!--Col-->
          </div><!--Row-->
        </template>
      </div><!--Col-->
    </div><!--Row-->
  </div>
</template>

<script>
export default {

data() {
    return {
        processing: false,
        show_load: false,
        form: {},
        records: [],
        columns: [
            {key: 'reference', label: 'Payment Reference'},
            {key: 'amount', label: 'Amount'},
            {key: 'status', label: 'Status'},
            {key: 'contact', label: 'Contact'},
            {key: 'type', label: 'Type'},
            {key: 'issued_at', label: 'Issued At'},
            {key: 'due_at', label: 'Due At'},
            {key: 'location', label: 'Location'},
            {key: 'portal', label: 'Portal'},
            {key: 'created_by', label: 'Creator'},
            {key: 'created_at', label: 'Created'},
            {key: 'updated_at', label: 'Updated'}
        ],
        options: [],
        queries: {},
        total: 0,
        client: {},
        payment_types: [],
        payment_descriptions: [],
        locations: [],
        portals: [],
        users: []
    }
},

mounted() {

    var self = this;

    const paymentCreatedHandler = function (data) {
        self.records.unshift(data);
        self.total++;
    };
    
    this.$eventBus.on('paymentCreated', paymentCreatedHandler);
    
    // Store handler for cleanup
    this.paymentCreatedHandler = paymentCreatedHandler;

    this.refreshRecords();

    const paymentsHandler = function (data) {
      self.pushRecord(data);
    };
    
    this.$eventBus.on('payments', paymentsHandler);
    
    // Store handler for cleanup
    this.paymentsHandler = paymentsHandler;

},

beforeUnmount() {
    // Clean up event listeners
    if (this.paymentCreatedHandler) {
        this.$eventBus.off('paymentCreated', this.paymentCreatedHandler);
    }
    
    if (this.paymentsHandler) {
        this.$eventBus.off('payments', this.paymentsHandler);
    }
},

created() {
      
    this.resetQueries();
    this.setURLParams();
    this.getOptions();

    this.getRecords();

    this.resetForm();

    if(this.record && this.record.uuid) {
        this.form = this.record;
    }

    this.getLocations();
    this.getPortals();
    this.getUsers();

},

methods: {

    resetQueries() {
      this.queries = {
          sortDirection: 'desc',
          sort: 'created_at',
          skip: 0,
          limit: 10,
          archived: false,
          trashed: false,
          upload: null,
          description: null,
          type: null,
          created_by: null,
          client: null,
          recurring: null,
          location: null,
          portal: null,
          citation: null,
          case_number: null
      }
    },


    getOptions () {
      this.$axios.get('https://ecdassets.s3-us-gov-east-1.amazonaws.com/js/options.json')
      .then(response => {
        if(response && response.data) {
            this.options = response.data;
        }
      })
    },

    resetRecords() {
        this.records = [];
        this.queries.skip = 0;
        this.total = 0;
    },

    searchRecords() {
      this.resetRecords();
      this.getRecords();
    },

    updateURL() {
        history.pushState({}, null, this.buildQueries('/'+this.$route.meta.base_url, this.queries));
    },

    getRecords() {

        this.processing = true;
        
        this.updateURL();
        this.getTotal();

        this.processing = true;
        this.$http.get(this.buildQueries('/'+this.$route.meta.base_url, this.queries))
        .then(response => {
            if(response && response.data) {

                if(response.data.length) {

                    var self = this;

                    response.data.forEach(function(data) {
                        self.records.push(data);
                    });
                
                }

                this.queries.skip = this.records.length;

                this.processing = false;
            }
        })
    },

    getTotal() {
        this.$http.get(this.buildQueries('/'+this.$route.meta.base_url+'/total', this.queries))
        .then(response => {
            if(response && response.status) {
                this.total = response.data;
            }
        })
    },

    resetClient() {
        this.queries.client = null;
        this.client = {};
    },

    closeClient() {
        this.resetClient();
        this.resetRecords();
        this.getRecords();
    },

    resetForm() {
        this.form = {
            client: null,
            contact: null,
            amount: null,
            reference: null,
            auto_message: null,
            type: 'fee'
        }
    },

    postForm() {

        this.form.status = 'outstanding';

        this.processing = true;

        this.$http.post('/'+this.$route.meta.base_url, this.form)
        .then(response => {
            if(response && response.data) {

                if(response.data.uuid) {
                  this.$eventBus.emit('alerts', {'message': this.$route.meta.title+' added', 'type': 'success'});

                  if(!this.records) {
                    this.records = [];
                  }

                  this.records.unshift(response.data);

                  this.total++;

                  this.resetForm();
                }

                this.processing = false;
          
            }
        })
    },

    pushRecord(data) {

      var count = this.records.length;

      if(this.records.length > count) {
        this.records.splice(-1);
      }

      var index = _.findIndex(this.records, {'uuid': data.uuid});

      if(index == -1) {
        this.records.unshift(data);
        this.total++;
        return;
      }

      var records = [];

      this.records.forEach(function(record) {

        if(record.uuid == data.uuid) {
          record = {...record, ...data};
        }

        records.push(record);


      })

      this.records = records;
    },

    setLocationName(record) {

      if(!record.location) {
        return;
      }

      var location = _.find(this.locations, {'uuid': record.location});

      if(!location || !location.name) {
        return;
      }

      return location.name;
    },

    setPortalName(record) {

      if(!record.portal) {
        return;
      }

      var portal = _.find(this.portals, {'uuid': record.portal});

      if(!portal || !portal.name) {
        return;
      }

      return portal.name;
    },

    getLocations() {
        this.$http.get('/locations?limit=1000&fields=name,uuid&sort=name&sortDirection=asc')
        .then(response => {
            if(response && response.data) {
                this.locations = response.data;
            }
        })
    },

    getPortals() {
        this.$http.get('/portals?limit=1000&fields=name,uuid&sort=name&sortDirection=asc')
        .then(response => {
            if(response && response.data) {
                this.portals = response.data;
            }
        })
    },

  getUsers () {
    this.$http.get('users?limit=1000&fields=name,email,uuid&sort=name&sortDirection=asc')
        .then(response => {
          if(response && response.data) {
            this.users = response.data;
          }
        })
  },


}

}
</script>
